import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillUpdated.meta';

export type UseTrackSkillUpdatedParams = {
  skill_id: string;
  scope: 'private' | 'workspace';
};

export const useTrackSkillUpdated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillUpdated = useCallback(
    (params: UseTrackSkillUpdatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillUpdated };
};
